import { fetchProducts } from '@/services/Firebase.ts'
import { useQuery } from '@tanstack/react-query'

export function useFetchProducts() {
  const query = useQuery({
    queryKey: ['billing', 'products'],
    queryFn: async () => {
      const result = await fetchProducts()
      return result.data.sort((a, b) => a.month.price - b.month.price)
    },
    staleTime: 1000 * 60 * 60 * 23, // refetch after 23h.
  })

  return query
}
